/**
 * DXE受渡確認票
 */
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/manifest/confirmation_slips`

const manifest_confirmation_slip = {
namespaced: true,
actions: {
  index ({ commit }, { params }) {
    return new Promise((resolve) => {
      Vue.$http.get(API_PATH, { params: params }).then(data => {
        resolve(data.content)
      })
    })
  },
},
}
export default manifest_confirmation_slip
